// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._11PtNh_o64qWw4ZljQJglS {\n    white-space: pre-wrap;\n    margin: 0;\n    font-size: 13px;\n    color: #32445A;\n    background-color: initial;\n    font-family: \"Open Sans\", sans-serif;\n    border: none;\n}\n", ""]);
// Exports
exports.locals = {
	"noteContents": "_11PtNh_o64qWw4ZljQJglS"
};
module.exports = exports;
